// Comete colors are used in LoadingScreen
// which is called before SettingsProvider(in index/PersistGate)

// Since the theme.palette isn't loaded yet,
// we need to store theses values elsewhere

const cometeColors = {
  lighter: '#e9effa',
  light: '#7488ab',
  main: '#22427c',
  secondary: '#f8bf01',
  secondaryLight: '#feeb17',
  contrastText: '#fff'
};

export default cometeColors;
